import React from 'react';
import { TextField } from '@mui/material';
import { useSelector } from 'react-redux';
import { ParcelDate } from '../types';
import Statuses from '../../../../fields/status.rider';

interface FilterControlsProps {
  get_search: string;
  set_search: (value: string) => void;
  getParcelDate: ParcelDate;
  setParcelDate: (value: ParcelDate) => void;
  get_status: any[];
  set_status: (value: string[]) => void;
}

interface ParcelState {
  parcel: {
    parcelStatus: { value: number; label: string }[];
  };
}

const FilterControls: React.FC<FilterControlsProps> = ({
  get_search,
  set_search,
  getParcelDate,
  setParcelDate,
  get_status,
  set_status,
}) => {
  const parcelStatusOptions = useSelector((state: ParcelState) => state.parcel?.parcelStatus);

  return (
    <div className="flex flex-wrap justify-between items-end">
      <div className="md:flex-1 w-full relative py-1 md:pr-1">
        <input
          type="search"
          placeholder="Search"
          value={get_search}
          className="pl-4 pr-10 py-4 w-full bg-white border border-gray-300 rounded-md shadow-sm focus:ring focus:ring-indigo-500 focus:border-indigo-500"
          onChange={(e) => set_search(e.target.value)}
        />
        <button
          type="button"
          className="absolute inset-y-0 right-0 pr-3 flex items-center"
          onClick={() => {
            // Trigger search logic here
          }}
        >
          <svg
            className="w-5 h-5 text-gray-500 hover:text-gray-700"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
            />
          </svg>
        </button>
      </div>
      <div className="py-1 md:pr-1 w-full md:w-auto">
        <TextField
          fullWidth
          label="Start Date"
          type="date"
          variant="outlined"
          value={getParcelDate.start || ''}
          onChange={(e) => {
            setParcelDate({ ...getParcelDate, start: e.target.value });
          }}
          className="p-4"
          InputLabelProps={{ shrink: true }}
        />
      </div>
      <div className="py-1 md:pr-1 w-full md:w-auto">
        <TextField
          label="End Date"
          type="date"
          fullWidth
          variant="outlined"
          value={getParcelDate.end || ''}
          onChange={(e) => {
            setParcelDate({ ...getParcelDate, end: e.target.value });
          }}
          className="p-4 mt-2"
          InputLabelProps={{ shrink: true }}
          disabled={!getParcelDate.start}
        />
      </div>
      <div className="w-full md:w-60 pb-3 md:pb-1 pt-1">
        <Statuses
          selectedStatuses={get_status}
          onChange={(selectedStatuses: string[]) => set_status(selectedStatuses)}
          options={parcelStatusOptions}
          multiple
          defaultValue={get_status}
        />
      </div>
    </div>
  );
};

export default FilterControls;
